import { render } from "./ServicePhases.vue?vue&type=template&id=639f086f&ts=true"
import script from "./ServicePhases.vue?vue&type=script&lang=ts"
export * from "./ServicePhases.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/witteveenbos/witteveenbos-light-modules/corporate-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__